import srcReviewJournal from './images/reviewjournal.png';
import srcVsin from './images/vsin.png';
import srcWp from './images/wp.png';

type Testimonial = { text: string; source?: string; role?: string; imgPath?: string };

const TESTIMONIALS: Testimonial[] = [
  // {
  //   text: '"The most respected pick service in the world."',
  //   source: 'Rob Pizzola',
  //   role: 'Professional bettor',
  //   imgPath: srcCirclesOff,
  // },
  // {
  //   text: `"When RAS bets, the world listens."`,
  //   source: 'Spanky',
  //   role: 'Professional bettor',
  //   imgPath: srcBeBetterBettors,
  // },
  {
    text: '"A pillar of the pick-selling industry."',
    source: 'Gill Alexander',
    role: 'VSiN host',
    imgPath: srcVsin,
  },
  {
    text: `"RAS is among just a handful of services whose picks consistently win."`,
    role: 'The Washington Post',
    imgPath: srcWp,
  },
  {
    text: `"The sports betting handicapping service that, over 25 years, has earned something
    rarely seen in the much-derided pick-selling industry: respect as a long-term winner."`,
    role: 'Las Vegas Review-Journal',
    imgPath: srcReviewJournal,
  },
];

export default function Testimonials() {
  return (
    <div className="mx-auto grid max-w-5xl grid-cols-1 space-y-8">
      {/* <div className="flex max-w-xl flex-col items-start justify-between"> */}
      {/* <div className="mt-8 flex flex-col justify-center space-y-4 px-4 sm:flex-row sm:space-x-8 sm:space-y-0 sm:px-0"> */}
      {TESTIMONIALS.map(({ text, source, role, imgPath }, index) => (
        <div
          // className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-8 pt-80 sm:pt-48 lg:pt-80"
          className="relative isolate flex flex-col items-center justify-between space-y-4 overflow-hidden rounded border border-white/5 bg-white/5 p-4 text-left shadow-2xl backdrop-blur-sm"
          key={index}
        >
          <div className="flex w-full flex-row items-start space-x-8">
            <img
              src={imgPath}
              height={80}
              className="h-20 w-auto shrink-0 grow-0 border border-white/10"
            />

            <div className="flex h-full flex-1 flex-col items-start justify-between space-y-4">
              <blockquote className="m-0 inline-block text-xl leading-tight text-zinc-200">
                {text}
              </blockquote>
              <figcaption className="text-left">
                <div className="text-sm font-semibold text-white">{source}</div>
                <div className="text-sm text-emerald-100/50">{role}</div>
              </figcaption>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
